/** TP sipariş oluşturma: gösterilen ve taslakta saklanan birim fiyat = net (fiyatgaranti) */

export const parseNetFiyat = (raw) => {
  if (raw == null || raw === '') return null;
  const n = parseFloat(raw);
  return Number.isFinite(n) ? n : null;
};

/** Parça kaydından net birim fiyat (gorunenFiyat öncelikli — taslak satırı) */
export function netFiyatFromParcaKaynak(parca) {
  if (!parca) return null;
  return (
    parseNetFiyat(parca.gorunenFiyat) ??
    parseNetFiyat(parca.fiyatgaranti) ??
    parseNetFiyat(parca.fiyatGaranti) ??
    null
  );
}

/** İçerik kartından net birim fiyat */
export function netFiyatFromIcerik(doc) {
  if (!doc) return null;
  return parseNetFiyat(doc.fiyatgaranti) ?? parseNetFiyat(doc.fiyatGaranti) ?? null;
}

/** Katalog satırından net birim (liste API) */
export function netFiyatFromParca(parca) {
  if (!parca) return null;
  return (
    parseNetFiyat(parca.fiyatgaranti) ??
    parseNetFiyat(parca.fiyatGaranti) ??
    null
  );
}
